<span class="title">Configuração do menu lateral</span>
<div class="menu-lateral-options">
	@for (options of MenuLateralOptions; track options) {
		<label [for]="options.value" class="option">
			<div>
				<img [src]="options.imgSrc" />
			</div>
			<div class="text">
				<input
					type="radio"
					name="menuViewMode"
					[value]="options.value"
					(change)="setMenuLateralViewMode(options.value)"
					[checked]="menuLateralService.menuLateralViewMode() === options.value"
					[id]="options.value" />
				<span>{{ labels[options.label] ? labels[options.label] : options.label }}</span>
			</div>
		</label>
	}
</div>
